export const airportList = [
  {
    title: 'transfer_details.airport_change.first_item.title',
    description: 'transfer_details.airport_change.first_item.description',
  },
  {
    title: 'transfer_details.airport_change.second_item.title',
    description: 'transfer_details.airport_change.second_item.description',
  },
  {
    title: 'transfer_details.airport_change.third_item.title',
    description: 'transfer_details.airport_change.third_item.description',
  },
]
